import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Text from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  label: string
  value: string | number
}

const MetricItem = ({ label, value }: Props) => {
  return (
    <ItemAlign align='center' gapX={4}>
      <Badge badgeType={BadgeType.SQUARE_TERTIARY_SECONDARY} size={12}>
        {label}
      </Badge>
      <Text>{value}</Text>
    </ItemAlign>
  )
}

export default MetricItem
